// extracted by mini-css-extract-plugin
module.exports = {"body":"Login_body__CMi2v"};